<template>
  <div class="evaluation_list">
    <div class="evaluation_list_title"></div>
    <van-list
      v-if="evaluationList.length > 0"
      v-model="pageParams.loading"
      :finished="pageParams.finished"
      :finished-text="pageParams.bottomText"
      :immediate-check="false"
      error-text="请求失败，点击重新加载"
      :error.sync="pageParams.error"
      @load="getEvaluationList()"
    >
      <ul class="list">
        <li
          class="list_item1"
          v-for="(item, index) in evaluationList"
          :data="JSON.stringify(item)"
          :key="item.id"
          @click="goDetail(item.id)"
        >
          <div class="evaluation_url_box">
            <van-image
              class="evaluation_url"
              :src="item.commentUrl"
              alt="商品图"
              fit="fill"
            />
          </div>
          <p class="evaluation_title">{{ item.commentContent }}</p>
          <div class="evaluation_info">
            <!-- 用户信息 -->
            <p class="user_info">
              <img
                class="head_img"
                :src="
                  item.userUrl ||
                  require('../../../../assets/images/trialProductsList/default-user-url.png')
                "
                alt=""
              />
              <span class="name">{{ item.userName }}</span>
            </p>
            <!-- 点赞数 -->
            <p class="fabulous_num" @click.stop="likeHandle(item, index)">
              <img
                v-show="item.needLike"
                src="../../../../assets/images/trialProductsList/liked.png"
                alt=""
              />
              <img
                v-show="!item.needLike"
                src="../../../../assets/images/trialProductsList/likeing.png"
                alt=""
              />
              <span>{{ item.likeNum }}</span>
            </p>
          </div>
          <div class="evaluation_commodity">
            <!-- 用户信息 -->
            <div class="commodity_info">
              <img
                class="commodity_img"
                :src="
                  item.goodsUrl ||
                  require('../../../../assets/images/trialProductsList/default-user-url.png')
                "
                alt=""
              />
              <div class="commodity_name_box" :data="JSON.stringify(item)">
                <p class="commodity_name">
                  {{ item.goodsName }}
                </p>
                <p class="commodity_name_a">点击进入商品详情</p>
              </div>
            </div>
            <div :key="item.goodsUrl" class="hometagWrap">
              <openWxTag
                :id="'evaluation-item-' + item.id + '-' + item.productId"
                :path="`/subPackages/shopMainProcess/product/index?productId=${item.productId}&skuId=${item.skuId}`"
                btnStyle="width:100%;height:52px"
                @sensorsFn="setPoint(item)"
              ></openWxTag>
            </div>
          </div>
        </li>
      </ul>
    </van-list>
    <div class="no_data" v-else>没有更多内容了～</div>
  </div>
</template>
<script>
import Index from './index.js'
export default Index
</script>
<style lang="less" scoped>
@import './index.less';
</style>
